import { L, } from '../leaflet/leaflet';
const _startViewMarkerIconSize = [12, 12], _endViewMarkerIconSize = [12, 12], _editMarkerIconSize = [24, 24], _endEditMarkerIconSize = [22, 22], L_divIcon = L.divIcon, _$markerIcons = {
    sv: L_divIcon({
        className: `route-view-icon-start`,
        iconSize: _startViewMarkerIconSize,
    }),
    ev: L_divIcon({
        className: `route-view-icon-end`,
        iconSize: _endViewMarkerIconSize,
    }),
    s: L_divIcon({
        className: `route-icon-start`,
        iconSize: _editMarkerIconSize,
    }),
    c: L_divIcon({
        className: `route-icon-corner`,
        iconSize: _editMarkerIconSize,
    }),
    e: L_divIcon({
        className: `route-icon-end`,
        iconSize: _endEditMarkerIconSize,
    }),
}, _markerSettings = {
    sv: {
        icon: _$markerIcons.sv,
    },
    ev: {
        icon: _$markerIcons.ev,
    },
    s: {
        icon: _$markerIcons.s,
        draggable: true,
    },
    c: {
        icon: _$markerIcons.c,
        draggable: true,
    },
    e: {
        icon: _$markerIcons.e,
        draggable: true,
    },
}, _lineSettings = {
    color: 'var(--route-color)',
    weight: 6,
};
export { _$markerIcons, _markerSettings, _lineSettings };
